import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonForm from "../../../components/form/form";
import { useEffect, useState } from "react";
import {
  createJobopening,
  updateJobopening,
} from "../../../../services/workspace/recruitment.service";

import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

import { getDepartmentList } from "../../../../services/workspace/department.service";
import { getDesignationList } from "../../../../services/workspace/designation.service";

import DefaultInput from "../../../components/inputs/defaultInput";
import DefaultTextarea from "../../../components/inputs/defaultTextarea";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";
import DefaultButton from "../../../components/buttons/defaultButton";
import CommonTable from "../../../components/table/table";
import CommonModal from "../../../components/modals/commonModel";
import { Icons } from "../../../../utils/icons";
import { fetchStaffList } from "../../../../store/slices/user.slice";
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from "../../../../services/workspace/user.service";
import { convertToLabelValue } from "../../../../utils/common";

const employment_type = [
  { label: "Permanent", value: "permanent" },
  { label: "Contractual", value: "contractual" },
];

const work_mode = [
  { label: "Office", value: "office" },
  { label: "Home", value: "home" },
  { label: "Hybrid", value: "hybrid" },
];

const currency = [
  { label: "INR", value: "inr" },
  { label: "Dollar", value: "dollar" },
  { label: "AED", value: "aed" },
];

const salary_type = [
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
];

// ---------------------------------------------------------

const AddJobOpening = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { staffList, staffLoading } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [editingRoundId, setEditingRoundId] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [isEditValue, setIsEditValue] = useState(null);
  const [rounds, setRounds] = useState([]);
   
  // ROUND MODAL
  const [roundModalOpen, setRoundModalOpen] = useState(false);

  const [roundForm, setRoundForm] = useState({
    name: "",
    description: "",
    marks: "",
    interviewer: "",
    mode: "",
  });

  useEffect(() => {
    dispatch(fetchStaffList({ type: 2}));
  }, [dispatch]);

  // const fetchStaff = () => {
  //   // setStaffLoading(true);
  //   getUserList()
  //     .then((response) => {
  //       // setStaffLoading(false);
  //       setStaffList(convertToLabelValue(response.user?.data || []) || []);
  //     })
  //     .catch((error) => {
  //       toast.error("Failed to fetch staff data!");
  //       console.log(error);
  //       // setStaffLoading(false);
  //     });
  // };
  // useEffect(() => {
  //   fetchStaff();
  // }, []);

  // const staffOptions = staffList.map((u) => ({
  //   label: u.name,
  //   value: u.id,
  // }));

  const breadcrumbs = [
    { label: "Job Opening", path: "/recruitment/job-opening" },
    { label: id ? "Edit Opening" : "Add Opening", path: "" },
  ];

  // ---------------- FETCHES ----------------

  useEffect(() => {
    getDepartmentList({})
      .then((res) =>
        setDepartmentList(convertToLabelValue(res.department?.data || []))
      )
      .catch(() => toast.error("Failed to fetch department data!"));

    fetchDesignation();
  }, []);

  const fetchDesignation = (departmentId = null) => {
    const params = { with: "department" };
    getDesignationList(params)
      .then((response) => {
        const list = Array.isArray(response?.designation?.data)
          ? response.designation.data
          : [];

        const filtered = departmentId
          ? list.filter(
              (item) => String(item?.department?.id) === String(departmentId)
            )
          : list;

        setDesignationList(convertToLabelValue(filtered));
      })
      .catch(() => {
        toast.error("Failed to fetch designation data!");
        setDesignationList([]);
      });
  };

  const handleDepartmentChange = (value) => {
    fetchDesignation(value);
  };

  // ---------------- FORM FIELDS ----------------

  const comprehensiveFields = [
    {
      label: "General Details",
      type: "section_header",
    },
    {
      name: "title",
      label: "Job Title",
      type: "text",
      required: true,
      colSpan: 3,
    },
    {
      name: "degination_id",
      label: "Designation",
      type: "select",
      options: designationList,
      colSpan: 3,
    },
    {
      name: "department_id",
      label: "Department",
      type: "select",
      options: departmentList,
      colSpan: 3,
      onChange: (value) => handleDepartmentChange(value),
    },
    {
      name: "no_of_vacancies",
      label: "Vacancies",
      type: "number",
      required: true,
      colSpan: 3,
    },
    {
      name: "employment_type",
      label: "Employment Type",
      type: "select",
      options: employment_type, // permanent and contractual
      colSpan: 3,
    },
    {
      name: "work_mode",
      label: "Work Mode",
      type: "select",
      colSpan: 3,
      options: work_mode, //office, home, or hybrid
    },
    { name: "opening_date", label: "Opening Date", type: "date", colSpan: 3 },
    { name: "closing_date", label: "Closing Date", type: "date", colSpan: 3 },
    { name: "address", label: "Location / Address", type: "text", colSpan: 3 },

    {
      label: "Requirements",
      type: "section_header",
    },

    {
      name: "minimum_education",
      label: "Minimum Education",
      type: "text",
      colSpan: 3,
    },
    {
      name: "preferred_education",
      label: "Preferred Education",
      type: "text",
      colSpan: 3,
    },
    {
      name: "minimum_experience",
      label: "Minimum Experience",
      type: "number",
      colSpan: 3,
    },
    {
      name: "maximum_experience",
      label: "Maximum Experience",
      type: "number",
      colSpan: 3,
    },
    { name: "key_skills", label: "Key Skills", type: "text", colSpan: 12 },
    {
      label: "Job Description",
      type: "section_header",
    },

    {
      name: "job_responsibilities",
      label: "Job Responsibilities",
      type: "textarea",
      colSpan: 12,
    },
    {
      name: "perks_benefits",
      label: "Perks & Benefits",
      type: "textarea",
      colSpan: 12,
    },
    {
      label: "Salary Range",
      type: "section_header",
    },
    {
      name: "currency",
      label: "Salary Currency",
      type: "text",
      colSpan: 3,
      options: currency, // inr, dollar, AED
    },
    {
      name: "salary_type",
      label: "Salary Type",
      type: "text",
      colSpan: 3,
      options: salary_type, // monthly and yearly
    },
    {
      name: "salary_min",
      label: "Minimum Salary",
      type: "number",
      colSpan: 3,
    },
    {
      name: "salary_max",
      label: "Maximum Salary",
      type: "number",
      colSpan: 3,
    },
  ];

  // ---------------- SUBMIT ----------------

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Transform rounds to match API structure
      const interview_rounds = rounds
        .filter((round) => round.name && round.mode && round.interviewer) // Filter out incomplete rounds
        .map((round) => {
          // Extract mode value
          const modeValue = typeof round.mode === "object" 
            ? round.mode.value 
            : round.mode;
          
          // Extract interviewer_id value
          const interviewerId = typeof round.interviewer === "object" 
            ? round.interviewer.value 
            : round.interviewer;

          return {
            name: round.name || "",
            mode: modeValue || "",
            marks: parseInt(round.marks) || 0,
            description: round.description || "",
            interviewer_id: parseInt(interviewerId) || null,
          };
        });

      // Normalize key_skills to always be an array (API requirement)
      const normalizedKeySkills = Array.isArray(values.key_skills)
        ? values.key_skills
        : typeof values.key_skills === "string" && values.key_skills.trim()
        ? values.key_skills.split(",").map((skill) => skill.trim()).filter(Boolean)
        : [];

      const payload = {
        ...values,
        key_skills: normalizedKeySkills,
        interview_rounds: interview_rounds.length > 0 ? interview_rounds : [],
      };

      if (isEditValue) {
        await updateJobopening(isEditValue.id, payload);
      } else {
        await createJobopening(payload);
      }

      navigate("/recruitment/job-opening");
    } catch {
      toast.error("Something went wrong");
    }

    setSubmitting(false);
  };

  const handleDraft = async (values, { setSubmitting }) => {
    try {
      // Transform rounds to match API structure
      const interview_rounds = rounds
        .filter((round) => round.name && round.mode && round.interviewer) // Filter out incomplete rounds
        .map((round) => {
          // Extract mode value
          const modeValue = typeof round.mode === "object" 
            ? round.mode.value 
            : round.mode;
          
          // Extract interviewer_id value
          const interviewerId = typeof round.interviewer === "object" 
            ? round.interviewer.value 
            : round.interviewer;

          return {
            name: round.name || "",
            mode: modeValue || "",
            marks: parseInt(round.marks) || 0,
            description: round.description || "",
            interviewer_id: parseInt(interviewerId) || null,
          };
        });

      // Normalize key_skills to always be an array (API requirement)
      const normalizedKeySkills = Array.isArray(values.key_skills)
        ? values.key_skills
        : typeof values.key_skills === "string" && values.key_skills.trim()
        ? values.key_skills.split(",").map((skill) => skill.trim()).filter(Boolean)
        : [];

      const payload = {
        ...values,
        status: 0,
        key_skills: normalizedKeySkills,
        interview_rounds: interview_rounds.length > 0 ? interview_rounds : [],
      };

      await createJobopening(payload);
      toast.success("Draft saved!");
      navigate("/recruitment/job-opening");
    } catch {
      toast.error("Failed to save draft");
    } finally {
      setSubmitting(false);
    }
  };

  const tableHeaderData = [
    { key: "name", label: "Round Name" },
    { key: "description", label: "Description" },
    { key: "mode", label: "Interview Mode" },
    { key: "marks", label: "Marks" },
    { key: "interviewer", label: "Interviewer" },
  ];
  useEffect(() => {
    const handleAddRound = (e) => {
      const newRound = e.detail;
      setRounds((prev) => [...prev, newRound]);
    };

    document.addEventListener("addRound", handleAddRound);

    return () => {
      document.removeEventListener("addRound", handleAddRound);
    };
  }, []);

  // Transform rounds for table display
  const tableData = rounds.map((round) => ({
    ...round,
    interviewer: typeof round.interviewer === "object" 
      ? round.interviewer.label 
      : round.interviewer,
    mode: typeof round.mode === "object" 
      ? round.mode.label 
      : round.mode,
  }));
  // --------------------------------------------------------

  const actionButton = {
    edit: (item) => {
      setEditingRoundId(item.id);
      setRoundForm({
        name: item.name,
        description: item.description,
        marks: item.marks,
        interviewer: item.interviewer,
        mode: item.mode,
      });
      setRoundModalOpen(true);
    },
    delete: (item) => {
      setRounds((prev) => prev.filter((r) => r.id !== item.id));
      toast.success("Round deleted");
    },
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={breadcrumbs} />

      <div className="bg-white p-4 space-y-4">
        <div className="p-3 bg-yellow-100 text-yellow-800 rounded border border-yellow-300 text-sm">
          ⚠️ Once interview rounds are added, avoid changing job details
          afterwards. It may cause data conflicts during evaluation.
        </div>

        <div className="flex flex-row justify-between items-center">
          <h1 className="text-lg font-semibold text-theme">Interview Rounds</h1>
          <DefaultButton
            name="Add Round"
            icon={Icons.ADD}
            onClick={() => setRoundModalOpen(true)}
          />
        </div>

        <CommonTable
          TableHeaderData={tableHeaderData}
          tabledata={tableData}
          action={actionButton}
        />
      </div>

      <div className="bg-white p-4">
        <CommonForm
          fields={comprehensiveFields}
          initialData={isEditValue || {}}
          onSubmit={handleSubmit}
          onDraft={handleDraft}
          submitButtonText="Save"
          draftButtonText="Save Draft"
          columnsPerRow={1}
        />
      </div>

      <CommonModal
        headerTitle="Add Interview Round"
        show={roundModalOpen}
        modalSize="xl"
        onClose={() => setRoundModalOpen(false)}
      >
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4 items-center">
            <DefaultInput
              label="Round Name"
              value={roundForm.name}
              onChange={(e) =>
                setRoundForm({ ...roundForm, name: e.target.value })
              }
            />
            <DefaultInput
              label="Total Marks / Points"
              type="number"
              value={roundForm.marks}
              onChange={(e) =>
                setRoundForm({ ...roundForm, marks: e.target.value })
              }
            />
            <DefaultSearchSelectInput
              label="Interviewer"
              options={Array.isArray(staffList) ? staffList : []}
              value={roundForm.interviewer}
              onChange={(val) =>
                setRoundForm({ ...roundForm, interviewer: val })
              }
            />
            <DefaultSearchSelectInput
              label="Interview Mode"
              options={[
                { label: "Office", value: "office" },
                { label: "Online", value: "online" },
                { label: "Hybrid", value: "hybrid" },
              ]}
              value={roundForm.mode}
              onChange={(val) => setRoundForm({ ...roundForm, mode: val })}
            />
          </div>

          <DefaultTextarea
            label="Description"
            rows={3}
            value={roundForm.description}
            onChange={(e) =>
              setRoundForm({ ...roundForm, description: e.target.value })
            }
          />
        </div>

        <div className="flex justify-start mt-4 gap-2">
          <DefaultButton
            name="Cancel"
            varient="danger"
            onClick={() => setRoundModalOpen(false)}
          />

          <DefaultButton
            name="Save"
            onClick={() => {
              // Validate required fields
              if (!roundForm.name || !roundForm.marks || !roundForm.interviewer || !roundForm.mode) {
                toast.error("Please fill all required fields");
                return;
              }

              if (editingRoundId) {
                // UPDATE EXISTING ROUND
                setRounds((prev) =>
                  prev.map((r) =>
                    r.id === editingRoundId
                      ? { 
                          ...roundForm, 
                          id: editingRoundId,
                          // Store full object for interviewer and mode to extract value later
                          interviewer: roundForm.interviewer,
                          mode: roundForm.mode,
                        }
                      : r
                  )
                );
              } else {
                // ADD NEW ROUND
                const newRound = {
                  ...roundForm,
                  id: Date.now(),
                  actions: true,
                  // Store full object for interviewer and mode to extract value later
                  interviewer: roundForm.interviewer,
                  mode: roundForm.mode,
                };
                setRounds((prev) => [...prev, newRound]);
              }

              // close + reset
              setRoundModalOpen(false);
              setEditingRoundId(null);
              setRoundForm({
                name: "",
                description: "",
                marks: "",
                interviewer: "",
                mode: "",
              });
            }}
          />
        </div>
      </CommonModal>
    </div>
  );
};

export default AddJobOpening;
